import sweetAlert from 'sweetalert';
import SidePanel from './sidepanel';
import displayDatatablesPagination from '../shared/datatables_pagination';
import { withSaveState } from '../shared/datatables_state';
import {
  overridePaginationClasses,
  customizeDOMPaginationClasses
} from '../../datatables/customization-v2';
import {
  setup as tableSetup,
  setupPaginationOnDOM,
  customizePageLength,
  evaluateSelectedRows,
  defaultTableOptions
} from '../../datatables/table-setup';

export const LISTS_TABLE_SELECTOR = '.event-parts-table';

const EventPartsTable = {
  start() {
    const $table = $(`${LISTS_TABLE_SELECTOR}:not(.dataTable)`);
    if (!$table.length) {
      return;
    }
    this.setupDataTable($table);
    this.watchDelete($table.DataTable());
    this.watchBulkEdit($table.DataTable());
    this.watchSelectionStart($table.DataTable());
  },

  watchDelete(table) {
    $('.js-delete-items').on('click', (event) => {
      const $button = $(event.currentTarget);
      const deleteUrl = $button.data('deleteUrl');
      const alertText = $button.data('alertText');
      sweetAlert({
        title: 'Warning!',
        text: alertText,
        icon: 'warning',
        dangerMode: true,
        buttons: ['Cancel', 'Delete']
      }).then((confirmed) => {
        if (!confirmed) return;
        const ids = $.map(
          table.rows({ selected: true }).nodes(),
          (row) => $(row).data('id')
        );
        $.ajax({ url: deleteUrl, method: 'DELETE', data: { event_part_ids: ids } })
          .done(() => { window.location.reload(); })
          .fail(() => {
            sweetAlert({ title: 'Error', text: 'The activities could not be deleted.', icon: 'error' });
          });
      });
    });
  },

  watchBulkEdit(table) {
    $('.js-bulk-edit-items').on('click', (event) => {
      const $button = $(event.currentTarget);
      const editUrl = $button.data('editUrl');
      const ids = $.map(
        table.rows({ selected: true }).nodes(),
        (row) => $(row).data('id')
      );
      SidePanel.show();
      SidePanel.load(editUrl, { event_part_ids: ids, kind: 'groups' });
    });
    $(document).on('change', '[name="group_action"]', function () {
      const isSet = this.value === 'set';
      const isRemove = this.value === 'remove';
      const hasLeadSelected = (isSet || isRemove) && table.rows({ selected: true }).nodes().toArray()
        .some((row) => $(row).data('activityType') === 'lead');
      $('#js-group-dropdown').toggleClass('is-hidden', !isSet);
      $('#js-set-group-lead-notice').toggleClass('is-hidden', !(isSet && hasLeadSelected));
      $('#js-remove-group-lead-notice').toggleClass('is-hidden', !(isRemove && hasLeadSelected));
    });
    SidePanel.onUpdate(() => {
      SidePanel.element().find('.js-bulk-edit-form').on('ajax:error', (event) => {
        const data = event.detail?.[0];
        sweetAlert({
          title: 'Error',
          text: data?.error || 'The activities could not be updated.',
          icon: 'error'
        });
      });
    });
  },

  watchSelectionStart(table) {
    table.on('select', () => {
      if (table.rows({ selected: true }).count() === 1 && SidePanel.element().hasClass('is-visible')) {
        SidePanel.reset();
      }
    });
  },

  tearDown() {
    $(`${LISTS_TABLE_SELECTOR}.dataTable`).DataTable().destroy();
  },

  setupDataTable($table) {
    overridePaginationClasses();
    const $checkAllCheckbox = $('#checkall');
    let table;
    const tableOptions = {
      ...defaultTableOptions,
      order: [[1, 'asc']],
      dom: 'rtp',
      select: {
        style: 'multi',
        selector: 'label.js-checkbox-for-row',
        className: 'is-selected'
      },
      columnDefs: [
        { targets: [0], orderable: false, width: '7%' },
        { targets: [1], orderable: true, width: '7%' },
        { targets: [2], searchable: true, width: '20%' },
        { targets: [-1], orderable: false, width: '9%' },
        { targets: '_all', searchable: false }
      ],
      drawCallback() {
        customizePageLength(this);
        customizeDOMPaginationClasses();
        evaluateSelectedRows(table, $checkAllCheckbox);
        displayDatatablesPagination(this);
      },
      initComplete: () => {
        setupPaginationOnDOM();
      },
      language: {
        ...defaultTableOptions.language,
        zeroRecords:
          '<span class="alert alert--info">Sorry, no matching Event Activities were found</span>',
        emptyTable: '<span class="alert alert--info">No Event Activities available</span>'
      }
    };
    const tableOptionsWithSaveState = withSaveState($table, tableOptions);
    table = $table.DataTable(tableOptionsWithSaveState);
    tableSetup(table);
  }
};

export default EventPartsTable;
